import http from '../request'
// 订场馆列表
export const getVenueList = params => {
  return http.get('/api/home/getVenueList', { params })
}

// 订场馆详情
export const getVenueDetails = params => {
  return http.get('/api/home/getVenueById', { params })
}

// 订场馆图集
export const getVenuePhotos = params => {
  return http.get('/api/home/getVenueImageByVenueId', { params })
}
